import { render, staticRenderFns } from "./LdapImportModal.vue?vue&type=template&id=b2a6c784&"
import script from "./LdapImportModal.vue?vue&type=script&lang=ts&"
export * from "./LdapImportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports